import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import MaintenanceCalculationForm from '../../../../components/forms/MaintenanceCalculationForm/MaintenanceCalculationForm';
import { Container, Row, Col } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axiosInstance from '../../../../utils/axiosConfig';

const EditCalculation = () => {
    const { id } = useParams();
    const location = useLocation();
    const [initialData, setInitialData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchMaintenanceData = async () => {
            // Check if data was passed via location state
            if (location.state?.maintenanceData) {
                setInitialData(location.state.maintenanceData);
                setLoading(false);
                return;
            }

            // Otherwise fetch from API
            if (id) {
                try {
                    const response = await axiosInstance.get(`/maintenance-calculator/${id}`);
                    const data = response.data.data || response.data;
                    setInitialData(data);
                } catch (error) {
                    console.error('Error fetching maintenance data:', error);
                    toast.error('Failed to load maintenance data');
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(false);
            }
        };

        fetchMaintenanceData();
    }, [id, location.state]);

    if (loading) {
        return (
            <Container fluid>
                <div className="mt-5 text-center">Loading...</div>
            </Container>
        );
    }

    if (!initialData) {
        return (
            <Container fluid>
                <div className="mt-5">No data available to edit. Please go back and select a vehicle.</div>
            </Container>
        );
    }

    return (
        <Container fluid>
            <div className="edit-maintenance-calculator-page mt-5 mb-5">
                <h3>Edit Maintenance Calculator - {initialData.vehicle_id}</h3>
            </div>

            <Row>
                <Col md={4}>
                    <h5>Edit Maintenance Calculator Details</h5>
                    <p>Update the maintenance pricing information below.</p>
                </Col>
                <Col md={8}>
                    <MaintenanceCalculationForm
                        initialData={initialData}
                        isEdit={true}
                    />
                </Col>
            </Row>
        </Container>
    );
};

export default EditCalculation;
